export const noop = (): void => void 0;
